import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment } from 'react';
import MainButton from '../agv-button';
import Status from '../agv-status/index';
import { useIsMobile } from '../../utils/useIsMobile';
import { Button } from 'react-bootstrap';

export default function Row({
  title,
  subtitle,
  iconColor,
  icon,
  onClick,
  buttonText,
  status,
  statusText,
  statusStyle,
  fields,
  style,
  actions,
  titleWidthClass,
}) {
  const isMobile = useIsMobile();

  return (
    <div
      className={`tw-flex ${
        isMobile
          ? 'tw-flex-col'
          : 'tw-flex-row tw-justify-between tw-items-center'
      } tw-p-3 ${style}`}
      onClick={buttonText ? null : onClick}
      key={title}
    >
      {/* Titre et Subtitle */}
      <div
        className={`tw-flex tw-items-center tw-min-w-0 ${
          isMobile
            ? 'tw-mb-3'
            : titleWidthClass
              ? `${titleWidthClass} tw-mr-4`
              : 'tw-flex-1 tw-mr-4'
        }`}
      >
        {icon && (
          <FontAwesomeIcon
            className={`tw-mr-2 tw-size-4 tw-shrink-0 ${iconColor}`}
            icon={icon}
          />
        )}
        <div className="tw-min-w-0 tw-flex-1">
          <div
            className={`tw-text-smi tw-font-work tw-leading-4 tw-mb-1 ${isMobile ? 'tw-line-clamp-3 tw-max-w-[200px]' : 'tw-line-clamp-1'} tw-text-ellipsis`}
          >
            {title}
          </div>
          <div
            className={`tw-text-smi tw-font-work tw-text-text-dark-medium-importance tw-leading-4 ${isMobile ? 'tw-line-clamp-3' : 'tw-line-clamp-1'} tw-text-ellipsis`}
          >
            {subtitle}
          </div>
        </div>
      </div>

      {/* Champs, Status et Bouton */}
      <div
        className={`tw-flex ${
          isMobile
            ? 'tw-flex-col'
            : 'tw-flex-row tw-items-center tw-min-w-fit tw-shrink-0'
        } ${isMobile ? 'tw-w-full' : 'tw-w-auto'}`}
      >
        {/* Conteneur des champs - vertical sur mobile, horizontal sur desktop */}
        <div
          className={`tw-flex ${
            isMobile ? 'tw-flex-col tw-gap-3' : 'tw-flex-row tw-items-center'
          } ${isMobile ? 'tw-mb-3' : ''}`}
        >
          {fields?.map((field, index) => (
            <Fragment key={`${field.name}-${index}`}>
              <div
                className={`tw-flex tw-flex-col ${
                  !isMobile
                    ? `tw-items-end tw-shrink-0 ${field.widthClass || ''}`
                    : 'tw-items-start tw-text-left'
                }`}
              >
                <div className="tw-text-smi tw-font-work tw-leading-4 tw-mb-1">
                  {field.name}
                </div>
                <div
                  className={`tw-text-smi ${
                    !isMobile
                      ? 'tw-items-end tw-text-right tw-truncate tw-max-w-full'
                      : 'tw-items-start tw-text-left'
                  } tw-font-work tw-text-text-dark-medium-importance tw-leading-4 tw-line-clamp-${!isMobile ? '1' : '2'}`}
                  title={
                    typeof field.value === 'string' ? field.value : undefined
                  }
                >
                  {field.icon && (
                    <FontAwesomeIcon
                      className={`tw-mr-1 tw-size-4`}
                      icon={field.icon}
                      color={field.color}
                    />
                  )}{' '}
                  {field.value}
                </div>
              </div>
              {index !== fields.length - 1 && !isMobile && (
                <div className="tw-h-4 tw-w-px tw-bg-background tw-mx-4" />
              )}
            </Fragment>
          ))}
        </div>

        {/* Séparateur et Status */}
        {fields?.length > 0 && status && statusText && !isMobile && (
          <div className="tw-h-4 tw-w-px tw-bg-background tw-mx-4" />
        )}
        {status && statusText && (
          <div className={`${isMobile ? 'tw-mb-3' : 'tw-w-[100px]'} `}>
            <Status style={statusStyle} status={status} text={statusText} />
          </div>
        )}

        {/* Bouton */}
        {onClick && buttonText && (
          <>
            {!isMobile && (
              <div className="tw-h-4 tw-w-px tw-bg-background tw-mx-4" />
            )}
            <MainButton
              style={!isMobile ? 'tw-ml-4' : ''}
              text={buttonText}
              onClick={onClick}
            />
          </>
        )}

        {actions && (
          <div className="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-ml-4">
            {actions.map((action, index) => (
              <button
                key={`${action.name}-${index}`}
                onClick={action.onClick}
                disabled={action.disabled}
                icon={action.icon}
                className={action.className}
              >
                <FontAwesomeIcon
                  className={`tw-mr-1 tw-size-3`}
                  icon={action.icon}
                  color={action.color}
                />
                {action.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
